/**
 * Panelde işaretli aktif dilleri herkese açık endpoint’ten çeker.
 * @returns {Promise<{ code: string, name: string }[] | null>} null = ağ/JSON hatası veya boş yanıt
 */
import { ENV } from '../../config/env'

export async function fetchSiteLanguages() {
  const base = ENV.API_BASE_URL.replace(/\/+$/, '')
  if (!base) return null
  try {
    const r = await fetch(`${base}/public/languages.php`)
    const body = await r.json()
    if (!body?.success || !Array.isArray(body?.data?.items)) return null
    const items = body.data.items
      .map((row) => ({
        code: String(row.code ?? '')
          .trim()
          .toLowerCase(),
        name: String(row.name ?? '').trim(),
      }))
      .filter((x) => x.code !== '')
      .map((x) => ({ code: x.code, name: x.name !== '' ? x.name : x.code }))
    return items.length > 0 ? items : null
  } catch {
    return null
  }
}
